const BOUNCE_CLASS = "el-dialog--bounce";

function playBounce(dialog) {
  dialog.classList.remove(BOUNCE_CLASS);
  void dialog.offsetWidth;
  dialog.classList.add(BOUNCE_CLASS);
}

function onOverlayClick(event) {
  const overlayDialog = event.target;
  if (!(overlayDialog instanceof Element)) return;
  if (!overlayDialog.classList.contains("el-overlay-dialog")) return;

  const dialog = overlayDialog.querySelector(".el-dialog");
  if (!dialog) return;

  requestAnimationFrame(() => {
    if (overlayDialog.classList.contains("is-closing")) return;
    const overlay = overlayDialog.closest(".el-overlay");
    if (!overlay || getComputedStyle(overlay).display === "none") return;
    playBounce(dialog);
  });
}

export function setupDialogBounce() {
  document.addEventListener("click", onOverlayClick);
}
